import React, { useEffect, useMemo, useState } from 'react' ; 
import "./ExtractMoreComments.css" ; 
import ListComments from '../../Components/Utils/ListComments';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice';
import { getAllCollectedCommentsAPI, getSavedComments, getSavedPosts } from '../../RTK/Slice/GroupData/CollectSlice';

const ExtractMoreComments = () => {

    // For Collect Comments In One Array
    const [allComments , setAllComments] = useState([]) ;  

    // For Access Token 
    const token = useSelector(getToken) ; 

    // For Access Posts
    const posts = useSelector(getSavedPosts) ; 

    // For Access Saved Comments
    const {comments , statusComments} = useSelector(getSavedComments) ; 

    // For Dispatch Action
    const dispatch = useDispatch() ; 

    // For Get User Token 
    const userToken = useSelector(getActiveToken) ;
    
    // For Get Random Number Between 1min and 2 min
    function getRandomBetween1And2Minutes(args) {
      // Convert minutes to milliseconds
      const min = args.t1 * 1000; // 1 minute in milliseconds
      const max = args.t2  * 1000; // 2 minutes in milliseconds
      
      // Generate random number between min and max
      return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const addComments = useMemo(()=>{
    if(posts.length !== 0){
      setAllComments(prv => [...prv , ...comments]) ; 
    }else{
      setAllComments([])  ;
    }
  } , [comments , posts])

    // For Get All Comments
    useEffect(()=>{
        if(posts.length > 0 ) {
            let time = 0 ; 
            let allIds = posts.map(item=> item.id)  ;
            for(let i = 0 ; i < allIds.length ;i++) {
              setTimeout(()=>{
                dispatch(getAllCollectedCommentsAPI({token , userToken , postId : allIds[i] }))
              } , time)
              time += getRandomBetween1And2Minutes({t1 : 3 , t2:6}) ;
            }
        }
    } , [posts])

    


  return (
    <div>
        <ListComments comments={allComments} statusOfComments={statusComments} />
    </div>
  )
}

export default ExtractMoreComments
